import "./wide-separator.scss";

export default function WideSeparator({ children }) {
  return <div className="wide-separator">{children}</div>;
}
